import VueKonva from 'vue-konva'
import { Group } from './custom-nodes/group'
const config = { customNodes: { Group } }

export { VueKonva, config }
